class Search {
    constructor(mainSelector, options) {
        let defaultOptions = {
            url: "",
            dropdownSelector: ".bar-search__list",
            inputSelector: ".bar-search__input",
            buttonSelector: ".bar-search__btn",
            keywordName: "keyword",
            symbolCount: 3,
            timer: 2 // TODO add timer func
        };

        this.options = Object.assign(defaultOptions, options);

        this.search = document.querySelector(mainSelector);

        if (this.search) {
            this.barSearchList = this.search.querySelector(this.options.dropdownSelector);
            this.buttonSelector = this.search.querySelector(this.options.buttonSelector);

            this.event();
        }

        // additional search page
        const buttonSearch = document.querySelector('#button-search');
        if (buttonSearch) {
            this.fullSearch(buttonSearch);
        }
    }

    // additional search page
    fullSearch(buttonSearch) {

        const checkedSubCategory = document.querySelector('input[name="sub_category"]');

        const subCategory = document.querySelector('select[name="category_id"]');

        if (subCategory) {
            if (subCategory.value == 0) {
                checkedSubCategory.removeAttribute("checked");
            } else {
                checkedSubCategory.removeAttribute("disabled");
            }

            subCategory.addEventListener('change', (e) => {
                if (e.target.value > 0) {
                    checkedSubCategory.removeAttribute("disabled");
                } else {
                    checkedSubCategory.removeAttribute("checked");
                    checkedSubCategory.setAttribute("disabled", true);
                }
            });
        }

        buttonSearch.addEventListener('click', (e) => {
            let url = 'index.php?route=product/search';

            const search = document.querySelector('#content input[name="search"]').value
            if (search)
                url += '&search=' + encodeURIComponent(search);

            const categoryId = document.querySelector('#content select[name="category_id"]').value;
            if (categoryId > 0)
                url += '&category_id=' + encodeURIComponent(categoryId);

            if (document.querySelector('#content input[name="sub_category"]').checked)
                url += '&sub_category=true';

            if (document.querySelector('#content input[name="description"]').checked)
                url += '&description=true';

            return window.location.assign(url);
        });
    }

    event() {
        const method = (window.navigator.userAgent.match(/Android/i)) ? 'input' : 'keyup';

        this.search.addEventListener(method, (e) => {
            const key = this.search.querySelector(this.options.inputSelector).value.toString();

            const data = (method == 'keyup') ? e.key : e.data;

            if (key.length >= (this.options.symbolCount) || data === "Enter")
                this.sendForm(key);
        });

        this.buttonSelector.addEventListener('click', (e) => {
            let arg = this.search.querySelector(this.options.inputSelector).value.toString();

            arg = (arg) ? "&search=" + arg : "";

            return window.location.assign("index.php?route=product/search" + arg);
        })
    }

    sendForm = (k) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', this.options.url);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.send(this.options.keywordName + '=' + k);

        xhr.onload = () => {
            if (xhr.readyState !== 4) return;
            // delete li before every request
            this.barSearchList.querySelectorAll('li').forEach(el => el.remove());

            if (xhr.status == 200) {
                const response = JSON.parse(xhr.response);

                if (response.length == 0) {
                    this.barSearchList.classList.remove("active");
                } else {
                    this.barSearchList.classList.add("active");
                }

                response.forEach(el => {
                    this.barSearchList.insertAdjacentHTML('beforeend', this.htmlRow(el));
                });

                // if (response.length) this.upDownKey();
            }
        }
    }

    upDownKey = () => {
        this.search.addEventListener('keyup', (e) => {
            if (e.key == 'ArrowUp' || e.key == 'ArrowDown') {
                // console.log(e.key)
            }
        })
    }

    htmlRow = (data) => {
        if (data['price'] === false)
            return `<li><a href="${data['href']}">${data['name']}</a>`;

        return `<li>
            <div class="name">
                <a href="${data['href']}">${data['name']}</a>
                <div class="model">${data['model']}</div>
            </div>
            <div class="price">${data['price']}</div>
            <div><a href="${data['href']}"><img src="${data['image']}"></a></div>`;
    }
}